var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconShiflow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 320"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 2",
    cx: 35,
    cy: 35,
    r: 35,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 49"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M47.5077 40.7967C42.402 40.7967 37.5769 38.4112 34.0688 36.0688L33.7666 35.8637C19.9391 26.8505 13.2143 35.5723 12.9336 35.9501C12.491 36.5438 11.6491 36.6733 11.0554 36.2308C10.4617 35.7882 10.3322 34.957 10.764 34.3526C10.8503 34.2338 12.966 31.3841 17.1326 29.9377C23.9761 27.563 30.9277 30.7473 35.5584 33.8344L35.8606 34.0395C49.6881 43.0635 56.4129 34.3418 56.6936 33.964C57.1362 33.3703 57.9781 33.2407 58.5718 33.6833C59.1655 34.1259 59.295 34.957 58.8632 35.5615C58.7769 35.6802 56.6612 38.5299 52.4946 39.9764C50.8323 40.5485 49.1592 40.7967 47.5077 40.7967Z",
    fill: "#3D404A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M36.4762 42.8477C34.2849 42.8477 31.8778 42.2324 29.5139 40.5377C23.6958 36.3711 17.4675 41.2393 17.2084 41.4552C16.6255 41.9193 15.7836 41.8222 15.3194 41.2501C14.8553 40.6672 14.9416 39.8253 15.5245 39.3611C18.277 37.1267 25.0774 34.0503 31.0791 38.3464C36.9295 42.5346 42.4238 38.1521 42.4778 38.109C43.0499 37.634 43.9026 37.7204 44.3668 38.3033C44.8417 38.8754 44.7554 39.7281 44.1725 40.1923C42.7045 41.4012 39.8332 42.8477 36.4762 42.8477Z",
    fill: "#3D404A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M45.2302 33.7265C43.0606 33.7265 40.7506 33.1437 38.5594 31.5677C32.7521 27.4119 27.3765 31.6325 27.1498 31.816C26.5669 32.2801 25.725 32.1938 25.2608 31.6109C24.7967 31.0388 24.883 30.186 25.4551 29.7219C27.9054 27.7249 34.1229 25.0803 40.1245 29.3764C45.975 33.5646 52.3652 28.5129 52.43 28.4697C53.0129 28.0056 53.8549 28.0919 54.319 28.6748C54.7832 29.2577 54.6968 30.0997 54.1139 30.5638C52.376 31.9779 48.9974 33.7265 45.2302 33.7265Z",
    fill: "#3D404A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShiflow);
export default __webpack_public_path__ + "static/media/icon-shiflow.7c811d1fb19a3ae57ac960d411c32108.svg";
export { ForwardRef as ReactComponent };